import { Observable } from 'rxjs';
import { get, isEmpty, omit } from 'lodash';
import LocalOrderService from 'apis/services/localOrder';
import { getDefaultPaginationStatus } from 'status/schemas/pagination';

export const initialState = getDefaultPaginationStatus();

const FETCH_LOCAL_ORDER = Symbol('FETCH_LOCAL_ORDER');
const FETCH_LOCAL_ORDER_SUCCESS = Symbol('FETCH_LOCAL_ORDER_SUCCESS');

export const fetchLocalOrder = params => ({ type: FETCH_LOCAL_ORDER, payload: params });
export const fetchLocalOrderSuccess = response => ({
  type: FETCH_LOCAL_ORDER_SUCCESS,
  payload: response,
});

export const fetchLocalOrderEpic = (action$, store$) => action$
  .ofType(FETCH_LOCAL_ORDER)
  .filter((action, index) => {
    const order = store$.value.localOrder;
    if (index === 0) {
      return true;
    }
    if (get(action, 'payload.forceRefresh', false)) {
      return true;
    }
    if (isEmpty(order.results)) {
      return false;
    }
    return get(action, 'payload.page', 0) !== get(order, 'current_page', -1);
  })
  .mergeMap(action => Observable
    .fromPromise(LocalOrderService.fetch(omit(action.payload, 'forceRefresh')))
    .map(response => fetchLocalOrderSuccess(response)),
  );


export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOCAL_ORDER_SUCCESS:
      return { ...action.payload.data };
    default:
      return state;
  }
};
